import packageInfo from '../../package.json';

export const environment = {
  //  baseUrl:'http://192.168.0.62:8083',
  // baseUrl:'https://chatty-cities-reply.loca.lt',
    baseUrl:'https://uat.chatadoc.com',
    // baseUrl:'http://10.5.50.17:8083',
    // 'POSTHOG_KEY':'phc_g1I0Asad82LSbNKHzpFueV8wLbwv2DlPANaxI949Gf0',
    // 'POSTHOG_HOST':'https://us.i.posthog.com',
    //  baseUrl:'https://api.mannkaa.com',
 
    // keyRazerPay: 'rzp_test_JrtXNXEBZZ9gzM', //Razepay Test Key
    keyRazerPay:'rzp_test_S3KKlBBN6uYyWs',
    // keyRazerPay: 'rzp_live_FtsfuQdSlTicnU', //Razepay Live Key
    stripeKey: 'pk_test_51K3jzwLplTQfgWbJRILDEE2QIul2pzVli5qssejXWs6W0mZBk6B1DBXItX8296TBN54h8Yblxo9R0hZcH6d2UJE000F8h9bI9m',
    // stripeKey: 'pk_live_51K3jzwLplTQfgWbJV05XHfZpCY2jvfoumzvWHuZRDG8AGOv54gPSgyGAtPg2FxuKGVNgqJbcOlb4fMmzdDfF9EGk005Z06O0n5',
      
    // baseUrl:'http://10.5.50.43:8083',//himanshu
    /* baseUrl:'http://10.5.50.53:8083', */ // shruti
    // baseUrl:'http://192.168.137.1:8083', // himanshu
    // baseUrl:'http://10.5.50.19:8083',
   
    production:true,
    version         : packageInfo.version,
    appName         : 'Mannkaa',
    firebaseConfig: {
      apiKey: "AIzaSyAU5kU7BaGPii-1s04cVQCPuEgji3E2P94",
      authDomain: "mannkaa-d2228.firebaseapp.com",
      projectId: "mannkaa-d2228",
      storageBucket: "mannkaa-d2228.appspot.com",
      messagingSenderId: "214074656101",
      appId: "1:214074656101:web:b4ee479019c05f39bccd8c",
      measurementId: "G-M92RFFMXNJ",
      vapidKey: 'BOROQEAoub3ofKAUxE2THD9uQYqEWzMkfe6VCt0w9UTDdGHzJlQbFCziwqc-XZ6uTF3UWCWTIygzNCDs5afT2Bo'
      },
    VAPID: 'BEtBorVG4ZDBrioCKr5ExoDmTbnPcr4_caEnKWWhTyZULi8KDu2nHYC2XqOFYQ9YNOFqzy7jqe-DUS5UfH5rHNE',
    ICON_URL: "https://landing.mannkaa.com",
    firebaseConfigForChat: {
       apiKey: "AIzaSyARbxmIxfLOOtRQuFGthn_VamdNnmY2hcI",
      
       authDomain: "mannkaa-chat-server-daa47.firebaseapp.com",
      
       databaseURL: "https://mannkaa-chat-server-daa47-default-rtdb.firebaseio.com",
      
       projectId: "mannkaa-chat-server-daa47",
      
       storageBucket: "mannkaa-chat-server-daa47.firebasestorage.app",
      
       messagingSenderId: "20425034280",
      
       appId: "1:20425034280:web:f92c5e36094cc90eea431d",
      
       measurementId: "G-GZPG6PS4Q8",
       vapidKey: 'BDAYKYLocsHeRc_Wn7udOlnbovHiWNaAAy5qcSQ7qljrWyfJ2YxOonY2fcIgoo_39rU1zsaZNm-C8cUqbSBkISs'
      

     }
};
